import React from 'react'
import translations from './translations'

translations.add('pt', {
    payNewCard: 'Pagar com novo cartão'
})
